module.exports = __webpack_public_path__ + "static/media/review-stars.fed92411.svg";